import React from 'react'
import styled from 'styled-components'
import {useTranslation} from 'i18n'
import {Button, Modal, Paragraph, RoboyuOffer} from 'common/components'
import convertUnit from 'lib/unit'
import {useSelector} from 'lib/redux'
import {GiftShopNewYuserConsentModalProps} from './GiftShopNewYuserNoticeModalProps'

const StyledModal = styled(Modal)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  width: 100%;
  max-width: ${convertUnit(295)};
  padding: ${convertUnit(20)};
  gap: ${convertUnit(20)};
`

const StyledTextContainer = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: ${convertUnit(12)};
`

const StyledImageContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`

const StyledButton = styled(Button)`
  flex: 1;
`

const StyledStepNumber = styled(Paragraph)`
  position: absolute;
  bottom: ${convertUnit(-40)};
  left: 0;
  right: 0;
  text-align: center;
`

export default function GiftShopNewYuserConsentModal({
  showStep,
  onConfirm,
  onBackdropPress,
}: GiftShopNewYuserConsentModalProps) {
  const {translate} = useTranslation()
  const {colorTheme} = useSelector('roboyuState')

  return (
    <StyledModal visible onBackdropPress={onBackdropPress}>
      <StyledImageContainer>
        <RoboyuOffer
          width={convertUnit(120)}
          height={convertUnit(120)}
          colorTheme={colorTheme.name}
        />
      </StyledImageContainer>
      <StyledTextContainer>
        <Paragraph fontSize="l" lineHeight={31}>
          {translate('giftShop:newYuserConsentFirst')}
        </Paragraph>
        <Paragraph fontSize="l" lineHeight={31}>
          {translate('giftShop:newYuserConsentSecond')}
        </Paragraph>
      </StyledTextContainer>
      <StyledButton label={translate('global:iAgree')} onClick={onConfirm} />
      {showStep && (
        <StyledStepNumber fontSize="l" fontWeight="bold" color="white_1">
          {translate('giftShop:xOfy', {x: 2, y: 2})}
        </StyledStepNumber>
      )}
    </StyledModal>
  )
}
